export function downloadModal() {
  const downloadForm = document.getElementById("centralized-pdf-form");
  const downloadFormClose = document.querySelector(".download-form-close");
  const downloadFormInner = document.querySelector(".download-form");

  if (downloadForm) {
    function closeForm() {
      downloadForm.classList.remove("show-form");
    }

    document.addEventListener(
      "click",
      function (event) {
        if (downloadForm.classList.contains("show-form")) {
          const isClickInsideForm = downloadFormInner.contains(event.target);
          const isClickOnCloseButton = downloadFormClose.contains(event.target);

          if (!isClickInsideForm && !isClickOnCloseButton) {
            closeForm();
          }
        }
      },
      true
    );

    downloadFormClose.addEventListener("click", function (event) {
      event.stopPropagation();
      closeForm();
    });
  }
}
